import { Component, OnInit, ViewChild, Inject, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';


export interface DeleteDialogData {

  delete_body_text: string;
  delete_api_url: string;
  delete_id: number;
  delete_header_text: string;
  isDelete: boolean | true;
  extra_data?: object;

}


@Component({
  selector: 'app-delete-dialog',
  templateUrl: 'grid-delete-dialog.html'
})

export class GridDeleteComponent implements OnInit {


  constructor(public dialogRef: MatDialogRef<GridDeleteComponent>, @Inject(MAT_DIALOG_DATA) public data: DeleteDialogData,
              private fb: FormBuilder, private http: HttpClient ) {}



  apiUrl = this.data.delete_api_url;
  id = this.data.delete_id;
  header = this.data.delete_header_text;
  body = this.data.delete_body_text;
  dodelete = this.data.isDelete || true;
  private baseURL = environment.baseUrl;

  ngOnInit() {



  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  delete(apiUrl: string, id: number) {


    if(this.dodelete === true) {
      const body = { id, ...(this.data.extra_data || {}) };
      this.http.post(this.baseURL + apiUrl + id, body).subscribe(
          () => this.dialogRef.close(1),
          err => {
            this.dialogRef.close(1),
            console.log('Error: ', err);
            console.log('Api: ' + apiUrl + id);
          }
      );
    }else {
      return;
    }


  }


}
